import React from 'react';

export interface IBackdropProps extends React.HTMLAttributes<HTMLDivElement> {
  isOpen: boolean;
  liftChildrenOnTrigger?: boolean;
}

export default function Backdrop({
  children,
  isOpen = false,
  liftChildrenOnTrigger = false,
  ...otherProps
}: React.PropsWithChildren<IBackdropProps>) {
  const initialClasses = ['backdrop-v2'];

  if (liftChildrenOnTrigger) {
    initialClasses.push('backdrop-lift-children');
  }

  const visibleClassName = 'backdrop-v2--visible';
  const hideBodyScrollClassName = 'backdrop-v2__body--visible';

  const [classes, setClasses] = React.useState<string[]>(initialClasses);

  React.useEffect(() => {
    if (isOpen && !classes.includes(visibleClassName)) {
      setClasses([...classes, visibleClassName]);
    } else if (!isOpen && classes.includes(visibleClassName)) {
      setClasses([...classes.filter(className => className !== visibleClassName)]);
    }
  }, [isOpen, classes]);

  React.useEffect(() => {
    if (isOpen && !document.body.classList.contains(hideBodyScrollClassName)) {
      document.body.classList.add(hideBodyScrollClassName);
    } else if (!isOpen && document.body.classList.contains(hideBodyScrollClassName)) {
      document.body.classList.remove(hideBodyScrollClassName);
    }
  }, [isOpen]);

  return (
    <>
      <div className={classes.join(' ')} {...otherProps}></div>
      {children}
    </>
  );
}
